// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"81de695d","496":"cd348932","532":"3fa686b5","661":"74825ae7","885":"8f13dbc5"}[chunkId] + ".chunk.js";
};